import {Button, Card, Space, Tag} from 'antd'
import React, {useCallback, useEffect, useRef, useState} from 'react'
import {News} from '../../entities/news'
import urlProjectPhoto0 from 'url:../../../public/assets/images/image1.jpg'
const {Meta} = Card
import {CalendarOutlined, RightOutlined} from '@ant-design/icons'
import {Link} from 'react-router-dom'
import './newsList.less'
import './home.less'
import {useIntl} from 'react-intl'
import dayjs from 'dayjs'

export type NewsCardProps = {
  news: News
  isFirst: boolean
}

export function NewsCard(props: NewsCardProps) {
  const coverH = props.isFirst ? 240 : 110
  const cardHeight = props.isFirst ? 420 : 200

  const intl = useIntl()

  const photoURL = props.news.titlePhotoURL ? props.news.titlePhotoURL : urlProjectPhoto0

  const Cover = (
    <div style={{position: 'relative'}}>
      <div
        style={{
          height: coverH,
        }}
      >
        <img
          className="home-layout__news-list__news-card__img"
          src={photoURL}
          alt={props.news.newsName}
        />
      </div>

      <div className="home-layout__news-list__news-card__tags">
        {(props.news.tags || []).slice(0, 2).map((t) => (
          <Tag
            key={t.id}
            className="home-layout__news-list__news-card__tags__tag"
            style={{color: t.color ? t.color : '#f58153'}}
          >
            {intl.locale === 'en' ? t.tagName : t.tagNameRu}
          </Tag>
        ))}
      </div>
    </div>
  )

  return (
    <div>
      <Card
        //className="news-card"
        hoverable
        cover={Cover}
        styles={{
          body: {padding: props.isFirst ? 16 : 14, height: cardHeight - coverH},
        }}
        style={{
          borderRadius: 12,
          overflow: 'hidden',
          boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
        }}
      >
        <div style={{width: '100%'}}>
          <div
            className="home-layout__news-list__news-card__title"
            style={{
              fontWeight: 800,
              fontSize: props.isFirst ? 24 : 18,
            }}
          >
            {intl.locale === 'en' ? props.news.newsName : props.news.newsNameRU}
          </div>

          <div>
            <span className="news-list-page__list__news__calendar">
              <CalendarOutlined />
              <span className="news-list-page__list__news__calendar__text">
                {dayjs(props.news.dateOfCreating).format('ll')}
              </span>
            </span>
          </div>

          {props.isFirst && (
            <div className="home-layout__news-list__news-card__text">{`${
              intl.locale === 'en' ? props.news.text : props.news.textRU
            }...`}</div>
          )}
        </div>
      </Card>
    </div>
  )
}
4
